import { Modal as AntModal } from "antd";
import { PropsWithChildren, ReactNode } from "react";
import "./Modal.scss";

export interface ModalProps {
    isVisible: boolean;
    onCancel?: () => void;
    onSubmit?: () => void;
    className?: string;
    width?: string;
    destroyOnClose?: boolean;
    closeIcon?: ReactNode;
    /** Show the antd corner close ("×") button. Defaults to antd's default (true). */
    closable?: boolean;
    title?: string;
    centered?: boolean;
    replaceDefaultStyles?: boolean;
    keyboard?: boolean;
}

export const Modal = ({
    isVisible,
    onCancel,
    onSubmit,
    className = "",
    width,
    children,
    destroyOnClose,
    closeIcon,
    closable,
    title,
    replaceDefaultStyles,
    keyboard,
}: PropsWithChildren<ModalProps>) => {
    return (
        <AntModal
            title={title}
            visible={isVisible}
            footer={null}
            onCancel={onCancel}
            onOk={onSubmit}
            className={`${replaceDefaultStyles ? className : `modal ${className}`}`}
            width={width}
            centered={true}
            destroyOnClose={destroyOnClose}
            closeIcon={closeIcon}
            closable={closable}
            keyboard={keyboard !== undefined ? keyboard : true}
        >
            {children}
        </AntModal>
    );
};
